module.exports = __webpack_public_path__ + "static/media/camera-off-02.43faa4ea.png";